import React, { useState, useEffect, useRef } from "react";
import "../assets/Waterscape.css";

import Contact from "./ContactUs";
import EnquiryForm from "./EnquiryForm";


import img1 from '../assets/imgs/Waterscape/backwaters.webp';
import img2 from '../assets/imgs/Waterscape/water-touch-bunglow.webp';
import img3 from '../assets/imgs/Investment-landing.webp';

import pfogg from '../assets/panshet_fogg/pfogg1.jpeg';
import pfogg2 from '../assets/panshet_fogg/pfogg2.jpeg';
import pfogg3 from '../assets/panshet_fogg/pfogg3.jpeg';


// ------------Development --------------------------------------

import d1 from '../assets/imgs/Waterscape/development/1.webp';
import d2 from '../assets/imgs/Waterscape/development/2.webp';
import d3 from '../assets/imgs/Waterscape/development/3.webp';
import d4 from '../assets/imgs/Waterscape/development/4.webp';
import d5 from '../assets/imgs/Waterscape/development/5.webp';
import d6 from '../assets/imgs/Waterscape/development/6.webp';
import d7 from '../assets/imgs/Waterscape/development/7.webp';
import d8 from '../assets/imgs/Waterscape/development/9.webp';
import d9 from '../assets/imgs/Waterscape/development/10.webp';
import d10 from '../assets/imgs/Waterscape/development/11.webp';
import d11 from '../assets/imgs/Waterscape/development/12.webp';

// -------------------Icons--------------------------
import gated from '../assets/imgs/Waterscape/icons/gated-community.webp';
import namePlate from '../assets/imgs/Waterscape/icons/name-plate.webp';
import road from '../assets/imgs/Waterscape/icons/road.webp';
import security from '../assets/imgs/Waterscape/icons/security-png.webp';
import treePlantation from '../assets/imgs/Waterscape/icons/tree-plantation.webp';
import water from '../assets/imgs/Waterscape/icons/water-connection.webp';
import streetlight from '../assets/imgs/Waterscape/icons/street-light.webp';


const imageCaptions = [
    "Mesmerizing Backwater View",
    "Luxurious Water-touch Bungalow",
    "Investment-Grade Scenic Landscape"
];

const Waterscape = () => {

    const [isEnquiryOpen, setEnquiryOpen] = useState(false);

    const toggleEnquiryModal = () => {
        setEnquiryOpen(!isEnquiryOpen);
    };



    const [activeTab, setActiveTab] = useState('nature');
    const [playVideo, setPlayVideo] = useState(false);

    const [isModalOpen, setModalOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const touchStartX = useRef(null);
    const touchEndX = useRef(null);

    const images = [img1, img2, img3,pfogg,pfogg2,pfogg3];

    const openModal = (index) => {
        setActiveIndex(index);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    const nextSlide = () => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const prevSlide = () => {
        setActiveIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    const handleTouchStart = (e) => {
        touchStartX.current = e.changedTouches[0].clientX;
    };

    const handleTouchEnd = (e) => {
        touchEndX.current = e.changedTouches[0].clientX;
        handleSwipe();
    };

    const handleSwipe = () => {
        if (!touchStartX.current || !touchEndX.current) return;
        const distance = touchStartX.current - touchEndX.current;
        if (distance > 50) {
            nextSlide(); // Swiped left
        } else if (distance < -50) {
            prevSlide(); // Swiped right
        }
    };

    return (


        <>




            <div className="waterscape-container">
                <div className="waterscape-header">
                    <h1 className="waterscape-title">Waterscape@Panshet Backwaters</h1>
                    <span className="waterscape-price">Rs. 17.5 Lakh onwards*</span>
                </div>
                <div className="waterscape-tag">Premium Water Touch/View Farmhouse Plots</div>
                <div className="waterscape-location">
                    <span>📍 Pole,Panshet Backwaters,Pune.</span>
                </div>

                <div className="waterscape-gallery">
                    <div className="waterscape-main-img" onClick={() => openModal(0)}>
                        <img src={images[0]} loading="lazy" alt="Main View" />
                        <p className="waterscape-caption">{imageCaptions[0]}</p>
                    </div>
                    <div className="waterscape-side-imgs">
                        <div onClick={() => openModal(1)}>
                            <img src={images[1]} loading="lazy" alt="Side View 1" />
                            <p className="waterscape-caption">{imageCaptions[1]}</p>
                        </div>
                        <div onClick={() => openModal(2)}>
                            <img src={images[2]} loading="lazy" alt="Side View 2" />
                            <p className="waterscape-caption">{imageCaptions[2]}</p>
                        </div>
                        <div onClick={() => openModal(3)}>
                            <img src={images[3]} loading="lazy" alt="Side View 2" />
                            <p className="waterscape-caption">{imageCaptions[3]}</p>
                        </div>
                        <div onClick={() => openModal(4)}>
                            <img src={images[4]} loading="lazy" alt="Side View 2" />
                            <p className="waterscape-caption">{imageCaptions[4]}</p>
                        </div>
                        <div onClick={() => openModal(5)}>
                            <img src={images[5]} loading="lazy" alt="Side View 2" />
                            <p className="waterscape-caption">{imageCaptions[5]}</p>
                        </div>
                    </div>
                </div>

                {isModalOpen && (
                    <div className="waterscape-modal-overlay" onClick={closeModal}>
                        <div
                            className="waterscape-modal fade-in"
                            onClick={(e) => e.stopPropagation()}
                            onTouchStart={handleTouchStart}
                            onTouchEnd={handleTouchEnd}
                        >
                            <span className="waterscape-close" onClick={closeModal}>&times;</span>
                            <img src={images[activeIndex]} loading="lazy" alt="Slide" className="fade-slide" />
                            <p className="waterscape-caption">{imageCaptions[activeIndex]}</p>
                            <div className="waterscape-modal-controls">
                                <button onClick={prevSlide}>❮</button>
                                <button onClick={nextSlide}>❯</button>
                            </div>
                        </div>
                    </div>
                )}



                <div className="waterscape-info-section">
                    <div className="waterscape-details">
                        <h2>Details</h2>
                        <div className="details-grid">
                            <div className="details-column">
                                <p><strong>Price :</strong> Rs. 17.5 Lakh Onwards*<span className="green"></span></p>
                                <p><strong>Open Phases :</strong> Phase - 1,2,3</p>
                                <p><strong>View :</strong> Backwaters View</p>
                                <p><strong>Plot Size From :</strong> 11,000 Sqft</p>
                                <p><strong>Possession Date :</strong> Immediate</p>
                            </div>
                            <div className="details-column">
                                <p><strong>Property Type :</strong> Agriculture Farmhouse Plotting Project</p>
                                <p><strong>Property Status :</strong> In development Phase</p>
                                <p><strong>Total Land Parcel :</strong> 100+ Acres </p>
                                <p><strong>Plot Size To :</strong> Acre</p>
                                <p><strong>Offer :</strong> </p>
                            </div>
                        </div>
                    </div>

                    <div className="waterscape-properties">
                        <div className="features-box">
                            <h2>Property Features</h2>
                            <ul>
                                <li>Individual Sale Deed & 7/12</li>
                                <li>Flexy EMI Available</li>
                                <li>Just Drive from Pune City</li>
                                <li>Proper demarcation to each plot</li>
                                <li>virgin Land (Red Soil)</li>
                                <li>Prime connection & easy connectivity</li>
                            </ul>
                        </div>
                        <div className="amenities-box">
                            <h2>Amenities</h2>
                            <div className="amenities-grid">
                                <div><span role="img" aria-label="Plantation">
                                    <img src={treePlantation} loading="lazy" width={50}></img> </span> 25 Tree Plantation</div>

                                <div><span role="img" aria-label="Security"><img src={security} loading="lazy" width={50}></img></span> Security Cabin</div>

                                <div><span role="img" aria-label="NamePlate"> <img src={namePlate} loading="lazy" width={50}></img>

                                </span> Name Plate</div>

                                <div><span role="img" aria-label="Games">

                                    <img src={road} loading="lazy" width={50}></img>

                                </span> Internal 20ft rodas</div>

                                <div><span role="img" aria-label="Water">

                                    <img src={water} loading="lazy" width={50}></img>

                                </span> Water Connection</div>

                                <div><span role="img" aria-label="Hall">
                                    <img src={streetlight} loading="lazy" width={50}></img>
                                </span> Street Light For Roads</div>

                                <div><span role="img" aria-label="Gate">
                                    <img src={gated} loading="lazy" width={50}></img>

                                </span> Gated Community</div>
                            </div>
                        </div>
                    </div>
                </div>




                <div className="waterscape-gated-community-benefits">
                    <h2>Benefits of Gated Community</h2>
                    <ul>
                        <li>Enhanced Security</li>
                        <li>Privacy</li>
                        <li>Higher Property Value</li>
                        <li>Well-maintained Infrastructure</li>
                        <li>Reduced Traffic & Noise</li>
                    </ul>
                </div>


                <div className="waterscape-strategic-location">
                    <div className="ws-location-container">

                        <div className="ws-location-right">
                            <h2>
                                Strategically Located for Convenience, Designed for Peace.
                            </h2>
                            <ul>
                                <li><span></span> From Pune <strong> 60km</strong></li>

                                <li><span></span> On project route nearby 27 <strong> Resorts</strong></li>

                                <li><span></span> Janani Mata Temple <strong> 3.0 Km</strong></li>

                                <li><span></span> Somjai Temple <strong> 4.0 Km</strong></li>

                                <li><span></span> Pole Gaon ST bus stop <strong> 1.5 Km</strong></li>

                                <li><span></span> Proposed Paragliding spot <strong> 1.5 Km</strong></li>

                                <li><span></span> Vardai Kund <strong> 4 Km</strong></li>

                            </ul>

                        </div>
                    </div>
                </div>



                <div className="ws-gallery">
                    <div className="gallery-tabs">
                        <button
                            className={activeTab === 'development' ? 'active' : ''}
                            onClick={() => setActiveTab('development')}
                        >
                            Site Development
                        </button>
                        <button
                            className={activeTab === 'nature' ? 'active' : ''}
                            onClick={() => setActiveTab('nature')}
                        >
                            Feel Waterscape Nature
                        </button>
                    </div>

                    <div className="ws-gallery">


                        <div className="gallery-content">
                            {activeTab === 'development' ? (
                                <div className="gallery-grid fade-in">
                                    <img src={d1} loading="lazy" alt="Development" />
                                    <img src={d2} loading="lazy" alt="Development" />
                                    <img src={d3} loading="lazy" alt="Development" />
                                    <img src={d4} loading="lazy" alt="Development" />
                                    <img src={d5} loading="lazy" alt="Development" />
                                    <img src={d6} loading="lazy" alt="Development" />
                                    <img src={d7} loading="lazy" alt="Development" />
                                    <img src={d8} loading="lazy" alt="Development" />
                                    <img src={d9} loading="lazy" alt="Development" />
                                    <img src={d10}loading="lazy"  alt="Development" />
                                    <img src={d11} loading="lazy" alt="Development" />
                                </div>
                            ) : (
                                <div className="gallery-grid fade-in">
                                    {!playVideo ? (
                                        <div className="video-thumbnail" onClick={() => setPlayVideo(true)}>
                                            <img src={img3} loading="lazy" alt="Video Thumbnail" />
                                            <div className="overlay">
                                                <div className="play-button">&#9658;</div>
                                                <span>WATCH NOW</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="video-wrapper">
                                            <iframe
                                                src="https://www.youtube.com/embed/mqYeJ62KfgA?autoplay=1"
                                                title="Waterscape Nature"
                                                frameBorder="0"
                                                allow="autoplay; encrypted-media"
                                                allowFullScreen
                                            ></iframe>

                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                </div>
            </div >


            {/* Floating Brochure Button */}
            <button className="ws-floating-btn" onClick={toggleEnquiryModal}>
                Get a Brochure
            </button>

            {/* Modal */}
            {isEnquiryOpen && (
                <div className="ws-modal-overlay" onClick={toggleEnquiryModal}>
                    <div className="ws-modal fade-in" onClick={(e) => e.stopPropagation()}>
                        <span className="ws-close" onClick={toggleEnquiryModal}>&times;</span>
                        <EnquiryForm />
                    </div>
                </div>
            )}



            <Contact />

        </>


    );
};

export default Waterscape;
